import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import Vue from 'expose-loader?exposes=Vue!vue';
import {BasketCountBadge} from './components/BasketCountBadge';
import './DadataName';
import './DadataAddress';
import './components/InputPhoneMask';
import $ from 'jquery';
import './DateMask';
import './DiscountPill';
import './ZipCode';
import './bitrix-bridge/BX.mod';
import './modal-auth-by-email';
import './EmailCapsFilter';
import 'expose-loader?exposes=ReviewMoodControl!./bitrix-bridge/ReviewMoodControl';
import 'expose-loader?exposes=addToCart&exposes=changeButton!./functions/tocart';
import 'expose-loader?exposes=ModalAjax|ModalAjax!./components/ModalAjax';
import 'expose-loader?exposes=showReviewAgreements|showReviewAgreements!./components/ReviewAgreements';
import 'expose-loader?exposes=showReviewNotAllowed|showReviewNotAllowed!./components/ReviewNotAllowed';
import './BonusFAQForm';
// import './service-map';
// import './service-map-round-controls';
import './bitrix-bridge/smartFilter';
import './bitrix-bridge/addReview';
import './bitrix-bridge/BuyWith';
import './carousel-products';
import './functions/productDescriptionMore';

import './header-search.desktop';
import './header-catalogue';
import './header-catalogue-dropdown';
import './nav-mobile';
import './banner-carousel';
import './category-filter';
import './product-gallery';
import './files';
import './legacy/sale-location-selector-search';

import initAdultModal from './bootstrap/initAdultModal';
import initModalAuthByPhone from './bootstrap/initModalAuthByPhone';
import initButtonFavourite from './bootstrap/initButtonFavourite';
import initButtonFavouriteTooltip from './bootstrap/initButtonFavouriteTooltip';
import initCountdown from './bootstrap/initCountdown';
import initDateAndTimeControls
    from 'expose-loader?exposes=initDateAndTimeControls|default!./bootstrap/initDateAndTimeControls';
import initProductSubscribe from './bootstrap/initProductSubscribe';
import initFormControls from "~/bootstrap/initFormControls";
import initLoader from "~/bootstrap/initLoader";
import initOrderForm from "~/bootstrap/initOrderForm";
import getScrollbarWidth from "~/functions/getScrollbarWidth";
import createModalStorage from "~/functions/createModalStorage";
import createBackdrop from "~/functions/createBackdrop";

const bootstrapApp = () => Promise.all([
    initAdultModal('#adult-modal'),
    initModalAuthByPhone('[is="modal-auth-phone"]'),
    initCountdown('.timer'),
    initButtonFavourite('.favourite, .favourites-button'),
    initButtonFavouriteTooltip('.product-card-favourite button'),
    initDateAndTimeControls(),
    initProductSubscribe('.product-info-block, .product-list__item'),

    initFormControls(),
    initLoader(),
    initOrderForm(),
    getScrollbarWidth(),
    createModalStorage(),
    createBackdrop(),
]);

Vue.component('basket-count-badge', BasketCountBadge);

$(function () {
    bootstrapApp();

    // Init Vue timers
    $('[is="basket-count-badge"]').toArray().forEach(el => new Vue({el}));

    // Костыли
    $(() => {
        const inputCount = document.querySelector('input#filteredProductCount');
        const place = document.querySelector('input#filteredProductCountPlace');

        if (inputCount && place && !isNaN(Number(inputCount.value))) {
            place.innerText = inputCount.value;
        }
    });
});
